import { CSSProperties } from 'react';

import { cx } from '@libs/classnames';

import styles from './PieChartIcon.module.css';

type Props = {
  className?: string;
  fillPercent: number;
};
export function PieChartIcon({ className, fillPercent }: Props) {
  return (
    <svg
      className={cx(styles.pieChartIcon, className)}
      style={{ '--fill-percent': fillPercent } as CSSProperties}
      viewBox="0 0 20 20"
    >
      <circle r="20" cx="10" cy="10" />
    </svg>
  );
}
